import { api } from './api';
import type { ProjectBrandingResponse, ProjectBrandingUpdate } from '../types/projectBranding';

export const projectBrandingApi = {
  get: (projectId: string) =>
    api.get<ProjectBrandingResponse>(`/api/projects/${projectId}/settings/branding`),

  update: (projectId: string, data: ProjectBrandingUpdate) =>
    api.put<ProjectBrandingResponse>(`/api/projects/${projectId}/settings/branding`, data),

  uploadLogo: (projectId: string, file: File) =>
    api.upload<ProjectBrandingResponse>(`/api/projects/${projectId}/logo`, file, 'logo'),

  removeLogo: (projectId: string) =>
    api.delete<ProjectBrandingResponse>(`/api/projects/${projectId}/logo`),
};
